import React, { useEffect } from "react";

import { Autocomplete, Stack, TextField } from "@mui/material";
import { AsyncContentMui } from "components/Async-content/AsyncContentMui";
import { useActionHook } from "hooks";
import { useReportsActions } from "store/actions-context";
import { ReportCashflowSet } from "store/types";

import { State } from "./CreateReportSection";

interface Props {
  data: { set_id: State["cashflow_graph"]["set_id"]; queries: State["queries"] };
  setData: (cb: (prevState: State["cashflow_graph"]) => State["cashflow_graph"]) => void;
  setQueriesData: (cb: (prevState: State["queries"]) => State["queries"]) => void;
}

export const SelectSet: React.FC<Props> = ({ data, setData, setQueriesData }) => {
  const { getCashflowSetsAction } = useReportsActions();
  const { set_id, queries } = data;

  const { action: getSets, data: sets = [], loading: setsLoading } = useActionHook(getCashflowSetsAction);

  useEffect(() => {
    getSets();
  }, []);

  const handleSetChange = (value: ReportCashflowSet) => {
    if (!value) return;

    setData(() => ({ set_id: value.id }));

    // If setQueriesData is provided and the set has params, update queries
    // if (setQueriesData && value?.params) {
    try {
      const params = JSON.parse(value.params || "{}");
      setQueriesData(() => ({
        filters: params.filters || {},
        dateRange: params.dateRange || queries.dateRange,
        exchangeMethod: params.exchangeMethod || queries.exchangeMethod,
        currency: params.currency || queries.currency
      }));
    } catch (error) {
      console.error("Failed to parse set params:", error);
    }
    // }
  };

  return (
    <Stack sx={{ gap: "10px", flexDirection: "row", alignItems: "center", minWidth: "300px" }}>
      <AsyncContentMui isLoading={setsLoading}>
        <Autocomplete
          fullWidth
          options={sets}
          renderInput={(params) => <TextField {...params} label="Prediction Parameters Set" />}
          value={sets.find((set) => set.id === set_id)}
          disableClearable
          getOptionLabel={(option) => option.name}
          renderOption={(props, option) => <li {...props}>{option.name}</li>}
          onChange={(_, value) => handleSetChange(value)}
        />
      </AsyncContentMui>
    </Stack>
  );
};
